import { render } from "./KYC.vue?vue&type=template&id=9616f014&scoped=true"
import script from "./KYC.vue?vue&type=script&lang=js"
export * from "./KYC.vue?vue&type=script&lang=js"

import "./KYC.vue?vue&type=style&index=0&id=9616f014&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9616f014"]])

export default __exports__